import MediaGallery from "./MediaGallery";
import { addResultImage, deleteResultImage, getResults } from "firestoreService";

const Results = () => (
  <MediaGallery
    title="Results"
    description="Result photos published on the public Results page."
    itemNoun="Result"
    fetchAll={getResults}
    addImage={addResultImage}
    removeImage={deleteResultImage}
  />
);

export default Results;
